import type { z } from "zod";

export function isTypeOf<S extends z.ZodType>(
    possible: unknown,
    schema: S,
): possible is z.infer<S> {
    return schema.safeParse(possible).success;
}

export function includeTypeOf<S extends z.ZodType>(schema: S) {
    return (possible: unknown): possible is z.infer<S> => isTypeOf(possible, schema);
}
